import { Get, Patch, Put } from '../helpers';

export type RegistrantResponse = {
  registration_id: number;
  event: number;
  created: string;
  email: string;
  bl_profile: number;
  values: Record<string, string>;
  uuid: string;
  marked_attended_by_admin: boolean | null;
  deleted: boolean;
  locations: Record<string, string | number>[];
  course_completed: boolean;
  pdf_url: string | null;
  generating_pdf?: string | false;
  avatar?: string;
  last_login?: string;
  first_name?: string;
  last_name?: string;
  passcode_list?: number;
  status?: string;
  starScore: number | '-';
  watchtimePercentage: number | '-';
};

export interface StepsCompleted {
  avatar: string[];
  general: number[];
  profile: string[];
}

export function ResetRegistrations({ eventUuid }: { eventUuid: string }) {
  return Put({
    path: `/v3/admin/event/audiences/registrants/${eventUuid}/reset`,
    authRequired: true,
    ignoreResponse: true,
    body: { eventUuid },
  });
}

export const GetRegistrants = ({
  eventUuid,
  offset,
  limit,
  search,
  getDeleted,
  coursesEnabled,
  sort,
  lists = '',
  status = '',
  uploadPasscodeList,
  start,
  end,
}: {
  eventUuid: string;
  offset: number;
  limit: number;
  sort?: string;
  search?: string;
  getDeleted?: boolean;
  coursesEnabled?: boolean;
  lists?: string;
  status?: string;
  uploadPasscodeList?: number;
  start?: number;
  end?: number;
}) => {
  const query = new URLSearchParams({
    offset: offset.toString(),
    limit: limit.toString(),
    search: search?.toString() || '',
    sort: sort?.toString() || '',
    deleted: getDeleted ? 'true' : '',
    courses: coursesEnabled ? 'true' : '',
    lists: lists.toString() || '',
    status: status ? status.toString() : '',
    uploadpasscodelist: uploadPasscodeList ? uploadPasscodeList.toString() : '',
    start: start ? start.toString() : '',
    end: end ? end.toString() : '',
  });
  return Get<{ registrations: RegistrantResponse[]; count: number }>({
    path: `/v3/admin/event/audiences/all-registrants/${eventUuid}?${query.toString()}`,
    authRequired: true,
    useCache: true,
    cacheTtl: 5,
  });
};

export const HideRegistrations = (registrations: string[], projectUuid: string): Promise<unknown> => {
  return Patch({
    path: '/v3/admin/events/hide-registrations',
    authRequired: true,
    body: { registrations, eventUuid: projectUuid },
  });
};

export const UnHideRegistrations = (registrations: string[]): Promise<unknown> => {
  return Patch({
    path: '/v3/admin/events/unhide-registrations',
    authRequired: true,
    body: { registrations },
  });
};

export const GetRegistrantStatusCounts = (eventUuid: string) => {
  return Get<Record<string, number>>({
    path: `/v3/admin/event/audiences/status-counts/${eventUuid}`,
    authRequired: true,
    useCache: true,
    cacheTtl: 5,
  });
};
